export default __webpack_public_path__ + "static/media/tutorial-export.8e93fe89.png";